import { render, staticRenderFns } from "./TagPagination.vue?vue&type=template&id=56b83004&scoped=true&"
import script from "./TagPagination.vue?vue&type=script&lang=js&"
export * from "./TagPagination.vue?vue&type=script&lang=js&"
import style0 from "./TagPagination.vue?vue&type=style&index=0&id=56b83004&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b83004",
  null
  
)

export default component.exports